import {useHistory} from 'react-router-dom'
import './ReferralComplete.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import Container from 'react-bootstrap/Container';
function ReferralComplete(){
    const history = useHistory()

    function handleSubmit(){
        history.push('/referraltab');
    }
    return(
        <>
        <Nav />
        <Container>
      
        <div class="center">
        
        <h1>Thank You!</h1>
        <p> Referral form is now complete and has been submitted. An email will be sent with instructions for the next steps.<br></br>
         Press start over if you want to submit another referral form.</p>
        <button class="btn btn-primary" type="submit" onClick={handleSubmit} > Start Over </button>
        </div>

        </Container>
    
        </>
    )
}

export default ReferralComplete;